export default __webpack_public_path__ + "static/media/blend-graph.d17ad9a8.svg";